<template>
<div>
  <v-app-bar app style='z-index: 10002' >
    <router-link to="/">
      <v-img
        class="mx-2 pb-3"
        src="../assets/logo.svg"
        max-width="150"
        contain
      ></v-img>
    </router-link>
    <v-spacer></v-spacer>
    <ProfileHeader/>
  
  </v-app-bar> </div></template>

<style scoped></style>

<script>
import ProfileHeader from "../components/ProfileHeader"

export default {
  name: "Header",

  components: {
    ProfileHeader
  },
 
};
</script>

